module.exports = __webpack_public_path__ + "img/emerald-coast-front-angle.2ceaa309.png";